import React from 'react';

import VenueImage from "../../images/neurocrine.png";

import "../../App.css";

import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';

import "./VenuePane.css";

export default function VenuePane(props) {

    return <React.Fragment>

        <div style={{
            marginTop: "15px",
            display: "inline-block",
            width: "100%",
            maxWidth: "600px"
        }}>
            <div style={{
                margin: "auto",
                width: "90%"
            }}>
                <img src={VenueImage} alt={"Venue"} width={"100%"}/>
            </div>
            <div>
                <div
                    style={{
                        marginTop: "15px",
                        fontFamily: "Libre Bodini",
                        fontWeight: "bold",
                    }}
                    className={"venue-title-font"}
                >
                    Neurocrine Biosciences
                </div>
                <div
                    style={{
                        fontFamily: "Libre Bodini",
                        marginTop: "20px",
                        fontWeight: "bold",
                    }}
                    className={"venue-std-font"}
                >
                    <a
                        rel={"noreferrer"}
                        style={{
                            color: "#FFF"
                        }}
                        target={"_blank"} href={"https://www.google.com/maps/dir//6027+Edgewood+Bend+Ct,+San+Diego,+CA+92130/" +
                    "data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x80dc0798ab42c5f1:0xbb9e5063a16071c6?sa=X&ved=1t:707&ictx=111"}>
                        6027 Edgewood Bend Ct
                        San Diego, CA 92130
                    </a>
                </div>
            </div>
        </div>

    </React.Fragment>
}